import { render, staticRenderFns } from "./SyncButton.vue?vue&type=template&id=d95a7f1a&scoped=true&"
var script = {}
import style0 from "./SyncButton.vue?vue&type=style&index=0&id=d95a7f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95a7f1a",
  null
  
)

export default component.exports